/* eslint-disable */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Title } from '../style';

const CgvParticular = () => {
  return (
    <Grid container alignItems="center" justify="center">
      <Grid item md={8} style={{ textAlign: 'center' }}>
        <Title>Condition générale de vente pour les particuliers</Title>
      </Grid>
      <Grid item md={8}>
        <h3>Préambule</h3>
        <p>
          L’Application Sympl est éditée par la société SAS DAT, société par
          actions simplifiée, immatriculée au Registre du commerce et des
          Sociétés de Paris sous le numéro 827776162, siégeant au 259, rue Saint
          Honoré — 75001 Paris, et représentée par son Président Monsieur
          Philippe Allouche, (ci-après « SYMPL »).
        </p>
        <h4>1- Glossaire & définitions</h4>
        <p>
          Les mots ci-dessous, dont la première lettre est en majuscules, seront
          définis comme tels dans les présentes conditions générales :
        </p>
        <p>
          <strong>Conditions générales de vente :</strong> conditions
          contractuelles dans le cadre desquelles s’effectue l’intégralité du
          service proposé par SYMPL.
        </p>
        <p>
          <strong>Conditions générales d’utilisation :</strong> conditions
          d’utilisation de l’Application Sympl.
        </p>
        <p>
          <strong>Application :</strong> désigne l’Application logicielle Sympl,
          éditée par le Prestataire et installée sur le téléphone mobile du
          Client, à l’initiative de ce dernier
        </p>
        <p>
          <strong>Client :</strong> personne utilisant l’un des produits
          développés par Sympl (module, Applications). Le Client passe commande
          en son nom, ou pour le compte d’une personne morale.
        </p>
        <p>
          <strong>Commande :</strong> désigne l’achat par le Client de la
          prestation de service proposée par SYMPL à savoir : récupération du ou
          des Objets du Client par le Coursier, son emballage par SYMPL et sa
          livraison par un Partenaire de SYMPL à l’adresse désignée par le
          Client.
        </p>
        <p>
          <strong>Coursier :</strong> désigne l’entité ou la personne
          responsable du retrait de la marchandise du Client, à l’adresse qu’il
          aura indiquée.
        </p>
        <p>
          <strong>Entrepôt :</strong> désigne le ou les locaux occupés par SYMPL
          dans lesquels les objets confiés par les clients sont pesés,
          conditionnés et remis aux Transporteurs.
        </p>
        <p>
          <strong>Objet :</strong> désigne les objets, produits ou marchandises
          que les Clients font livrer en utilisant les services proposés par
          SYMPL.
        </p>
        <p>
          <strong>Partenaire :</strong> désigne l’ensemble des transporteurs
          partenaires utilisés par Sympl. Les transporteurs sont La Poste,
          Colissimo, Chronopost, DPD France, TNT, DHL, UPS, Colis Privé. Cette
          liste est susceptible d’évoluer. Notre système informatique
          sélectionne le partenaire adéquat en fonction des caractéristiques de
          la commande et du mode de livraison choisi par le Client.
        </p>
        <p>
          <strong>Politique de confidentialité :</strong> règles relatives à
          l’exploitation des données personnelles des Clients du site. La
          Politique de confidentialité détaille l’utilisation faite des données
          personnelles du Client du site, ainsi que les droits dont il dispose
          sur ces données.
        </p>
        <p>
          <strong>Prix :</strong>prix total du service proposé par SYMPL. Les
          prix sont entendus toutes taxes comprises pour les particuliers.
        </p>
        <p>
          <strong>Service :</strong> désigne l’ensemble des prestations fournies
          par SYMPL
        </p>
        <p>
          <strong>Transporteur :</strong> désigne la société sélectionnée et
          mise en relation avec le Client par l’intermédiaire de SYMPL qui sera
          chargée de la livraison de ou des produits confiés de l’Entrepôt SYMPL
          à l’adresse déterminée par l’utilisateur.
        </p>
        <p>
          <strong>Validation de la commande :</strong> acceptation de la
          commande passée par le Client de l’Application.
        </p>
        <h4>2- Champs d'application</h4>
        <p>
          Les présentes conditions générales d’utilisation s’appliquent, sans
          restriction ni réserve à tout achat des Services décrits à l’article 3
          ci-dessous proposés par la société SYMPL/SAS DAT aux Clients
          professionnels et non professionnels sur toute application liée au
          service SYMPL.
          <br />
          <br />
          Les caractéristiques principales des Services sont présentées sur
          l’Application SYMPL. Le Client est tenu d’en prendre connaissance
          avant toute passation de commande, le choix et l’achat d’un service
          étant de la seule responsabilité du Client.
          <br />
          <br />
          Les présentes Conditions Générales d’Utilisation s’appliquent à
          l’exclusion de tous autres conditions.
          <br />
          <br />
          Elles sont accessibles à tout moment sur l’Application et prévaudront,
          le cas échéant, sur toute autre version ou tout autre document
          contradictoire.
          <br />
          <br />
          Le Client déclare avoir pris connaissance des présentes Conditions
          Générales d’Utilisation de l’Application et les avoir acceptées en
          cochant la case prévue à cet effet avant la validation de la procédure
          de commande en ligne.
          <br />
          <br />
          La validation de la commande de Service par le Client vaut acceptation
          sans restriction ni réserve des présentes Conditions Générales
          d’Utilisation.
          <br />
          <br />
          Ces conditions pouvant faire l’objet de modifications ultérieures, la
          version applicable à la Commande du Client est celle en vigueur sur le
          site internet à la date de passation de la Commande.
          <br />
          <br />
          Le Client reconnaît avoir la capacité requise pour contracter et
          acquérir les services proposés sur l’appli SYMPL.
          <br />
          <br />
          Si l’une des clauses s’avérait, pour quelque raison que ce soit,
          inapplicable, nulle ou non valide, le retrait de ladite disposition
          n’affecterait pas la validité et l’opposabilité des autres
          stipulations du contrat dans son ensemble.
          <br />
          <br />
          Sauf preuve contraire, les données enregistrées dans le système
          informatique du prestataire constituent la preuve de l’ensemble de la
          transaction conclue avec le Client.
        </p>
        <h4>3- Objet du service Sympl</h4>
        <p>
          Le service Sympl a pour vocation de proposer une solution logistique à
          la demande simplifiée, en permettant aux particuliers d’externaliser
          leur système logistique.
          <br />
          <br />
          Sympl mandate au nom et pour le compte du Client un Coursier pour
          acheminer l’Objet au sein de son Entrepôt, se charge de l’emballage de
          l’Objet puis sélectionne mandate au nom et pour le compte du Client un
          commissionnaire de transport ou un Transporteur pour livrer l’Objet à
          l’adresse de livraison indiquée par le Client.
          <br />
          <br />
          Sympl fournit ce Service via l’Application et le module SYMPL mais n’a
          pas en aucun cas la qualité de commissionnaire de transport ou de
          transporteur.
        </p>
        <h4>4. Engagements du Client</h4>
        <p>
          Le Client s’engage à se conformer aux dispositions des présentes
          Conditions générales ainsi que celles des partenaires de SYMPL. Le
          Client s’engage également à respecter les lois et règlements en
          vigueur dans tous les pays concernés par le transport des produits
          acheminés par les Services de SYMPL.
        </p>
        <p>
          Le Client s’engage à ne pas perturber ou entraver le bon
          fonctionnement de l’Application.
        </p>
        <p>
          Le Client s’engage à fournir les informations exactes nécessaires à
          l’utilisation de l’Application, pour son compte, comme tout tiers
          empruntant ses données. Toutes les données récoltées sur l’Application
          relative à l’exécution des Services constituent des preuves recevables
          et opposables entre les parties dans le cadre d’une procédure
          judiciaire.
        </p>
        <p>
          Le Client s’engage à n’entraver aucun droit de propriété
          intellectuelle de tiers.
        </p>
        <p>
          Le Client s’engage à ne pas usurper l’identité d’un autre Client de
          l’Application, et à respecter la vie privée d’autrui.
        </p>
        <p>
          Le Client s’engage à ne pas porter atteinte à l’intégrité de
          l’Application, et à ne pas collecter d’information personnelle sur un
          autre Client.
        </p>
        <p>
          Le Client s’engage à payer les sommes dues suite à sa commande. Le
          Client est responsable du paiement de sa commande. Le Client est
          également responsable du paiement effectué pour le compte d’un mineur,
          ou d’un tiers.
        </p>
        <p>
          Le Client s’engage à ne faire qu’un usage strictement personnel des
          Services de SYMPL. La revente des Services à un tiers est strictement
          prohibée. Chaque compte Client SYMPL, nom du Client et mot de passe,
          sont strictement personnels ; le Client s’engage à ne pas les
          divulguer à un tiers. Le Client s’engage à ne pas céder ou transférer
          le compte Client, nom du Client et mot de passe, à un tiers, personne
          physique ou morale. La confidentialité et la fiabilité du mot de passe
          et du nom du Client sont de l’unique responsabilité de le Client.
        </p>
        <p>
          Le Client s’engage à fournir toute preuve d’identité si SYMPL le juge
          raisonnablement opportun et nécessaire.
        </p>
        <p>
          Le Client s’engage à utiliser l’Application et le module en conformité
          avec sa finalité.
        </p>
        <p>
          Le Client s’engage à ne pas utiliser le Service à des fins de nuisance
          envers un tiers
        </p>
        <p>
          Le Client s’engage à ne pas copier ou distribuer le contenu de SYMPL,
          de quelque manière que ce soit, sans avoir préalablement obtenu
          l’accord écrit de ses dirigeants.
        </p>
        <h4>5 - Prix et modalités de paiement</h4>
        <h4>5.1. DETERMINATION DU PRIX</h4>
        <p>
          Les Services proposés par SYMPL sont fournis aux tarifs en vigueur sur
          le site internet lors de l’enregistrement de la commande.
        </p>
        <h3>5.1.1. Détermination du prix estimatif :</h3>
        <p>
          Le prix estimatif communiqué au Client préalablement à la validation
          de sa commande est présenté sous forme de fourchette (prix minimum
          estimé – prix maximum estimé). Le prix estimatif est déterminé en
          fonction des informations qui ont été communiquées par le Client :
          poids dimension et photo. Le prix est donc susceptible de varier au
          delà de la fourchette estimée s’il s’avérait que les indications
          renseignées dans l’Application étaient erronées.
        </p>
        <h3>5.1.2. Détermination du prix définitif</h3>
        <p>
          Le prix définitif est calculé dès son arrivée dans l’Entrepôt de SYMPL
          en fonction des dimensions exactes et du poids de l’objet transporté.
        </p>
        <p>
          La facture est simultanément adressée au Client et précise les
          éléments qui ont servi à la détermination du prix.
        </p>
        <p>Le Client recevra une facture par commande. </p>
        <p>
          SYMPL garantit la stricte confidentialité des données bancaires
          transmises. SYMPL s’engage à n’en faire aucun usage de quelque nature
          que ce soit.
        </p>
        <h3>5.2 Modalité de reglement</h3>
        <p>
          Le prix est payable comptant en totalité au jour de la passation de la
          commande par le Client par voie de paiement sécurisé par carte
          bancaire.
        </p>
        <p>
          Les données de paiement sont échangées de manière sécurisée en
          utilisant le protocole de communication TLS.
        </p>
        <p>
          Une somme égale à la fourchette haute du prix estimatif est bloquée
          sur le compte bancaire du Client au moment de la validation de la
          commande.
        </p>
        <p>
          Le prix du Service est effectivement encaissé au moment de la
          détermination du prix définitif et de l’émission de la facture.
        </p>
        <p>
          Le prestataire ne sera pas tenu de procéder à la fourniture des
          services commandés par le Client si le prix ne lui a pas été
          préalablement réglé en totalité dans les conditions ci-dessus
          indiquées.
          <br />
          Les paiements effectués par le Client ne seront considérés comme
          définitifs qu’après encaissement effectif des sommes dues.
        </p>
        <h3>6- Réalisation de la prestation</h3>
        <p>
          La livraison est assurée par les transporteurs sélectionnés par le
          prestataire dans les délais déterminés en fonction des options
          choisies.
        </p>
        <h3>7 – Refus légitime de commande</h3>
        SYMPL se réserve le droit de refuser le traitement de certaines
        commandes, notamment si elles émanent d’un Client insolvable et/ou avec
        lequel SYMPL a précédemment rencontré des différents dans le paiement de
        ses Services. Il en est de même en cas de violation des présentes
        Conditions générales.
        <br />
        <br />
        SYMPL se réserve le droit de refuser le traitement de commandes si,
        malgré ses efforts, elle est dans l’impossibilité de permettre
        l’acheminement des colis, notamment du fait d’un cas de force majeure
        imprévisible, irrésistible, extérieure.
        <br />
        SYMPL se réserve également le droit de ne pas traiter les commandes
        relevant d’une tentative de fraude, ou du transport d’objets illicites
        tels que définis ci-dessous.
        <br />
        <br />
        SYMPL se réserve le droit de refuser le traitement des commandes dont
        les informations requises révélaient la présence de propos injurieux,
        inacceptables, ou illégaux.
        <br />
        <br />
        SYMPL informe son Client que ne pourront être pris en charge, sans que
        cette liste soit exhaustive : les bijoux et articles d’horlogerie
        composés même partiellement de pierres et métaux précieux, les pierres
        et métaux précieux, les monnaies, devises, billets de banque, valeurs
        financières, titres ou moyens de paiement et notamment les effets de
        commerce, les cartes téléphoniques, chèques cadeaux, ou tout autres
        support permettant un paiement fongible, l’intégralité des articles
        relevant des dispositions des règlementations nationales et
        internationales sur les produits dangereux comme, sans que cette liste
        soit exhaustive: les gaz, munitions, matières inflammables,
        radioactives, toxiques, infectieuses ou corrosives. Ne peuvent également
        être pris en charge les animaux ou êtres vivants ou morts, les
        marchandises soumises à une certaine température, les denrées
        périssables, les armes à feu ou armes de guerre ou de collection, les
        objets d’art ou antiquités, tout objet qui par leur conditionnement ou
        nature sont susceptibles de présenter un danger pour le personnel de
        transport ou de logistique, les véhicules ou engins de transport, les
        tiers.
        <br />
        SYMPL refusera également l’acheminement des supports audiovisuels
        interdits par toute loi ou règlementation applicable, tout produit
        contrefait ou issu de la contrefaçon. Sont également refusés les objets
        immoraux, les médicaments, le tabac, les stupéfiants, les matières
        psychotropes, les cendres ou reliques funéraires.
        <h3>8. Pénalités</h3>
        Dans tous les cas de refus de commande au départ du destinataire, dans
        les conditions visées ci-dessus, une pénalité forfaitaire égale à 5 €
        par lot de 10 objets à récupérer simultanément à la même adresse pour la
        même destination. Dans cette hypothèse, le solde du prix du Service
        bloquée sur le compte du Client lui sera restitué.
        <br />
        Il en est de même en caS de refus de l’objet à l’entrepôt. Toute
        annulation ou modification survenue plus d’un quart d’heure après la
        commande du Coursier entrainera la facturation du prix du Service soit 5
        € par lot de 10 objets. Les commandes ne pourront être ni annulées ni
        modifiées après la prise en charge des colis par le Partenaire.
        <br />
        Toute modification de la commande est susceptible d’en modifier le prix.
        En procédant à la modification de sa commande, le Client est réputé
        accepter le nouveau calcul de prix. L’annulation ou la modification de
        la commande n’est effective que lorsque le Client en aura reçu une
        confirmation dans l’Application ou par courriel.
        <h3>9. Rétractation, modification, annulation de la commande</h3>
        <p>
          Compte tenu de la nature du service fourni, le Client reconnaît être
          informé par les présentes Conditions générales, qu’en vertu des
          dispositions de l’article L. 121-20-4 du Code de la consommation, les
          Services de transport proposés par SYMPL ne sont pas soumis au droit
          de rétractation prévu aux articles L. 121-20 et suivants du même Code.
          Les présentes Conditions générales régissent toute rétractation,
          modification ou annulation de la commande effectuée sur l’Application.
        </p>
        <p>Il en est de même en cas de refus de l’objet à l’entrepôt. </p>
        <p>
          Cas d’impossibilité de livrer du transporteur dû à la faute ou la
          négligence du Client (notamment, absence de destinataire et
          d’instructions pour nouvelle présentation) : le prix de la commande
          restera acquis à SYMPL majorée d’une pénalité forfaitaire de 10 € que
          le Client devra régler afin que son ou ses Objet(s) lui soit restitué.
        </p>
        <h3>10. Assurances & limitations de responsabilité</h3>
        <h3>10.1. LA LIVRAISON</h3>
        <p>
          En cas de perte, ou de dommage avéré du colis, SYMPL s’engage, sur
          présentation de factures et de toute pièce justificative (photos des
          colis endommagés, déclaration de perte ou de vol, sans que cette liste
          soit exhaustive), à rembourser à son Client la valeur du ou des
          Objet(s) dans la limite trois cents (300) Euros par Commande sans
          frais aucun.
        </p>
        <p>
          Pourront seuls être indemnisés dans les conditions du présent article
          les pertes et dommages directs causés aux biens ce qui exclue le
          dédommagement des pertes de chance ou perte de gain.
        </p>
        <p>
          Pour tout colis de valeur supérieure à trois cents (300) Euros, le
          Client peut choisir de souscrire une assurance supplémentaire, dont le
          montant est calculé selon un (1) pourcentage (%) de la valeur totale
          du colis. En cas de perte, et sur présentation d’une facture, le
          Client se verra rembourser à hauteur de la valeur déclarée pour cet
          envoi.
        </p>
        <p>
          SYMPL décline toute responsabilité relative à une erreur de saisie ou
          une insuffisance dans les informations communiquées par le Client ou
          insuffisance des garanties souscrites.
        </p>
        <p>
          SYMPL ne saurait être tenu responsable de la discontinuité de
          fonctionnement de son Application, en cas de modification, de
          piratage, de difficulté technique, d’erreurs, de bugs, d’anomalies,
          qui ne sauraient engager sa responsabilité civile ou pénale.
        </p>
        <p>
          SYMPL ne peut garantir la compatibilité de son Application avec un
          matériel ou des installations à configuration particulière. Aucun
          dysfonctionnement imputable à des installations incompatibles ou des
          logiciels de tiers ne saurait engager la responsabilité de SYMPL.
        </p>
        <p>En cas de survenance d’un sinistre, le Client s’engage :</p>
        <ul>
          <li>
            à indiquer sur le document présenté par le transporteur lors de la
            livraison toutes les réserves, décrire les dommages, préciser la
            date le lieu
          </li>
          <li>
            à en informer SYMPL dans les 48 heures de la livraison par lettre
            recommandée avec accusé de réception accompagné de tous les
            justificatifs et références nécessaires, afin que SYMPL en avertisse
            immédiatement son partenaire. Le fait que SYMPL se présente comme
            intermédiaire entre le Client, le Coursier, le Logisticien et le
            Transporteur ne saurait engager sa responsabilité de quelque manière
            que ce soit.
          </li>
        </ul>
        <p>
          Nonobstant ces considérations, SYMPL s’engage à fournir ses meilleurs
          efforts en vue d’assurer l’exécution de la commande du Client, et
          d’apporter la solution adaptée à la mauvaise exécution ou
          l’inexécution des prestations de ses partenaires, sans que ses efforts
          ne s’analysent comme constitutifs de l’engagement d’une responsabilité
          de quelque nature que ce soit.
        </p>
        <h3>10.2. LE STOCKAGE</h3>
        <p>
          SYMPL décline toute responsabilité résultant de dommages ou
          détériorations subies par les produits périssables qui auraient été
          remis à SYMPL en vue de leur stockage préalablement à leur livraison.
        </p>
        <p>
          En cas de perte, de vol ou de sinistre (incendie, dégât des eaux…)
          ayant affecté les produits non périssables confiés à SYMPL, ce dernier
          s’engage, sur présentation de factures et de toute pièce justificative
          (photos des colis endommagés, déclaration de perte ou de vol, sans que
          cette liste soit exhaustive), à rembourser à son Client la valeur du
          stock confié dans la limite totale de 100.000 € (100.000 €) Euros.
        </p>
        <p>
          Pourront seuls être indemnisés dans les conditions du présent article
          les pertes et dommages directs causés aux biens ce qui exclue le
          dédommagement des pertes de chance ou perte de gain.
        </p>
        <p>
          Lorsque la valeur des produits confiés par le Client à SYMPL est
          supérieure CENT MILLE (100.00 €), le Client peut choisir de souscrire
          une assurance supplémentaire, dont le montant est calculé selon un (1)
          pourcentage (%) de la valeur totale du colis. En cas de perte, vol ou
          détérioration, et sur présentation d’une facture, le Client se verra
          rembourser à hauteur de la valeur déclarée pour cet envoi.
        </p>
        <h3>10.3. SINISTRE RELATIF AU FONCTIONNEMENT DE L’APPLICATION</h3>
        <p>
          SYMPL décline toute responsabilité relative à une erreur de saisie ou
          une insuffisance dans les informations communiquées par le Client ou
          insuffisance des garanties souscrites.
        </p>
        <p>
          SYMPL ne saurait être tenu responsable de la discontinuité de
          fonctionnement de son Application, en cas de modification, de
          piratage, de difficulté technique, d’erreurs, de bugs, d’anomalies,
          qui ne sauraient engager sa responsabilité civile ou pénale.
        </p>
        <p>
          SYMPL ne peut garantir la compatibilité de son Application avec un
          matériel ou des installations à configuration particulière. Aucun
          dysfonctionnement imputable à des installations incompatibles ou des
          logiciels de tiers ne saurait engager la responsabilité de SYMPL.
        </p>
        <p>
          SYMPL décline toute responsabilité résultant d'éventuels dommages
          découlant de l'utilisation (ou de l'incapacité à utiliser) de
          l’Application, y compris des dommages causés par des logiciels
          malveillants, des virus ou par une quelconque inexactitude ou omission
          d'informations, sauf si les dommages découlent d'un acte délibéré ou
          d'une grave négligence de SYMPL.
        </p>
        <p>
          Par ailleurs, SYMPL décline toute responsabilité résultant de dommages
          découlant de l'utilisation (ou de l'incapacité à utiliser) des moyens
          électroniques de communication avec l’Application, notamment les
          dommages découlant d'un échec ou d'un retard de transmission de
          communications électroniques, d'une interception ou d'une manipulation
          de communications électroniques par des tiers ou par des programmes
          informatiques utilisés pour des communications électroniques et la
          transmission de virus.
        </p>
        <h3>11. Code promotionnel</h3>
        <p>
          SYMPL peut à sa seule discrétion et selon ses conditions propres,
          décider d’octroyer des codes promotionnels en vue de la réduction du
          coût des Services proposés.
        </p>
        <p>
          Ces codes promotionnels peuvent être octroyés aux Clients des Services
          de SYMPL, comme à de nouveaux Clients. Le refus d’octroi d’un tel
          code, pour des raisons relevant de l’entière discrétion de SYMPL, ne
          saurait donner lieu à compensation ou indemnisation.
        </p>
        <h3>12. Loi applicable et compétence juridictionnelle</h3>
        <p>
          Les présentes Conditions générales sont régies par la loi française.
        </p>
        <p>
          Le Client qui souhaiterait assigner pour quelque raison que ce soit,
          s’engage à en informer préalablement SYMPL, et de fournir ses
          meilleurs efforts en vue de régler le litige à l’amiable.
        </p>
        <p>
          Si aucun accord ne s’avère envisageable, les litiges seront portés
          devant le Tribunal de commerce de Paris.
        </p>
        <h3>13. Propriété intellectuelle</h3>
        <p>
          L’intégralité des éléments de l’Application et, notamment, sans que
          cette liste soit exhaustive, les photographies, graphiques, images,
          codes, mises en forme, textes, illustrations, arborescences, relèvent
          de la propriété intellectuelle exclusive de SYMPL ou SAS DAT.
        </p>
        <p>
          En vertu des dispositions de l’article L. 122-4 du Code de la
          propriété intellectuelle, et que ce soit à titre commercial ou non, la
          représentation, rediffusion, imbrication ou reproduction, intégrale ou
          partielle, et, plus généralement, toute exploitation non autorisée, et
          œuvre dérivée, de l’intégralité des éléments de l’Application, sont
          illicites. « SYMPL » est une marque déposée. Toute Utilisation de son
          nom, ou son logo, nécessite l’accord préalable de ses titulaires, sous
          peine d’Application des articles L. 713-2 et suivants du Code de la
          propriété intellectuelle.
        </p>
        <p>
          Le Client s’engage à respecter l’intégralité des droits de propriété
          intellectuelle de SYMPL s’expose à des poursuites judiciaires, et
          notamment à la caractérisation du délit de contrefaçon (sans que ce
          dernier soit exhaustif) dont les peines sont reportées aux articles L.
          335-2 et suivants du Code de la propriété intellectuelle, et engage sa
          responsabilité civile comme pénale.
        </p>
        <p>
          SYMPL informe son Client que les données nécessairement récoltées pour
          l’exécution de ses Services ne seront pas transférées en dehors du
          territoire de l’Union Européenne.
        </p>
        <p>
          SYMPL informe son Client qu’il a pris toutes les précautions utiles à
          la récolte de ces données à caractère personnel, et qu’elles sont
          conservées dans des conditions optimales de sécurité et dans le
          respect de toutes les dispositions légales et règlementaires en
          vigueur au moment de votre commande.
        </p>
        <p>
          Nous traitons ce type de données de façon loyale et licite et en
          respectant vos droits.
        </p>
        <h3>14. Loi informatique et liberté</h3>
        <p>
          En application de la loi n°78-17 du 6 janvier 1978 modifiée par la loi
          du 6 août 2004 dite « Informatique et Libertés », il est rappelé que
          les données nominatives qui sont demandées au Client sont nécessaires
          au traitement de sa commande et à l’établissement des factures,
          notamment.
        </p>
        <p>
          Ces données peuvent être communiquées aux éventuels partenaires du
          Vendeur chargés de l’exécution, du traitement, de la gestion et du
          paiement des commandes.
        </p>
        <p>
          Le traitement des informations communiquées par l’intermédiaire de
          l’application SYMPL a fait l’objet d’une déclaration auprès de la CNIL
          (déclaration n° 1873271 v 0).
        </p>
        <p>SYMPL récolte de manière loyale les données de son Client. </p>
        <p>
          SYMPL informe son Client qu’elle ne recueille aucune donnée dite «
          sensible » faisant apparaître de façon directe ou indirecte, ses
          origines raciales, ethniques, opinions politiques, philosophiques,
          religieuse, comme les données relatives à sa santé ou sa vie sexuelle,
          ainsi que toute appartenance syndicale.
        </p>
        <p>
          Le Client est informé et accepte que certaines de ses données
          personnelles soient récoltées en vue de la stricte exécution des
          Services qu’il a expressément commandés.
        </p>
        <p>
          En commandant sur l’Application via les formulaires proposés, le
          Client consent à la récolte et au traitement des données personnelles
          qu’il inscrit volontairement.
        </p>
        <p>
          Le responsable du traitement de ces données personnelles est SYMPL. Le
          traitement de ces données personnelles est exclusivement destiné à
          mieux vous connaître afin de permettre l’exécution des Services
          volontairement et expressément commandés par le Client, à savoir la
          proposition d’une solution logistique à la demande simplifiée, en
          permettant aux professionnels et aux particuliers d’externaliser leur
          système logistique.
        </p>
        <p>
          Aucune donnée à caractère personnel ne sera recueillie sans votre
          accord exprès et préalable. Votre accord est réputé exprès après le
          clic validant votre commande, après validation des présentes
          Conditions générales.
        </p>
        <p>
          Les données sont exclusivement destinées aux membres de SYMPL, afin de
          permettre la bonne exécution de ses Services.
        </p>
        <p>
          SYMPL informe son Client que ses données à caractère personnel ne sont
          récoltées que pour une durée n’excédant pas la finalité de la
          collecte.
        </p>
        <p>
          Conformément à la loi informatique et liberté du 6 janvier 1978, le
          Client dispose à tout moment d’un droit d’accès, de rectification et
          d’opposition à l’ensemble de ses données personnelles en écrivant par
          courrier et en justifiant de son identité à :
        </p>
        <p>SAS DAT, 259, rue Saint Honoré 75001 Paris</p>
      </Grid>
    </Grid>
  );
};

export default CgvParticular;
